import styled from 'styled-components/macro';
import {
  FormControl,
  InputAdornment,
  InputLabel,
  OutlinedInput,
} from '@material-ui/core';
import OpenInNewOutlinedIcon from '@material-ui/icons/OpenInNewOutlined';
import { withStyles } from '@material-ui/styles';
import React, { useRef } from 'react';
import { fontWeightBold, montserrat } from 'variables/font';
import { brand, brandLighter, grey50 } from 'variables/colors';
import { FlexCenterVertical } from 'styles/flexbox';

const StyledForm = withStyles(() => ({ root: { margin: '.72em 0' } }))(
  FormControl,
);

const CopyLinkButton = styled.span`
  color: ${brand};
  font-weight: ${fontWeightBold};
  font-size: 0.875em;
  font-family: ${montserrat};
  background: 0;
  border: 0;
  outline: 0;
  cursor: pointer;

  &:hover {
    color: ${brandLighter};
  }
`;

const LinkWrapper = styled.a`
  font-size: 1em;
`;

const OpenScheduler = styled(FlexCenterVertical)`
  margin-top: 0.5em;
  cursor: pointer;

  &:hover {
    color: ${grey50};
  }
`;

const LinkText = styled.h5`
  margin-left: 0.5em;
`;

const SchedulerLinkField = ({ link }) => {
  const inputRef = useRef(null);
  const schedulerLink = `${process.env.REACT_APP_CLIENT_DOMAIN_URL}/${link}`;

  const handleCopyLink = () => {
    navigator.clipboard.writeText(schedulerLink);
  };

  if (!link) {
    return null;
  }

  return (
    <StyledForm variant="outlined">
      <InputLabel htmlFor="standard-adornment-copy-scheduler-link">
        Scheduler Link
      </InputLabel>

      <OutlinedInput
        labelWidth={120}
        ref={inputRef}
        endAdornment={
          <InputAdornment position="end">
            <CopyLinkButton onClick={handleCopyLink}>Copy link</CopyLinkButton>
          </InputAdornment>
        }
        defaultValue={schedulerLink}
        value={schedulerLink}
      />

      <LinkWrapper href={schedulerLink} target="_blank">
        <OpenScheduler>
          <OpenInNewOutlinedIcon />
          <LinkText>Open Scheduler</LinkText>
        </OpenScheduler>
      </LinkWrapper>
    </StyledForm>
  );
};

export default SchedulerLinkField;
